import { Controller } from "@hotwired/stimulus"

/**
 * Handles template selection in the post builder.
 *
 * When a completable template card is clicked, shows the corresponding
 * pre-rendered completion form and highlights the selected card.
 */
export default class extends Controller {
  static targets = ["card", "completionForm"]

  selectTemplate(event) {
    const templateId = event.currentTarget.dataset.templateId

    // Highlight selected card, unhighlight others
    this.cardTargets.forEach(card => {
      const isSelected = card.dataset.templateId === templateId
      card.classList.toggle("border-brand_main", isSelected)
      card.classList.toggle("ring-2", isSelected)
      card.classList.toggle("ring-brand_main/20", isSelected)
      card.classList.toggle("border-gray-200", !isSelected)
    })

    // Show matching completion form, hide others
    this.completionFormTargets.forEach(form => {
      form.classList.toggle("hidden", form.id !== `completion-form-${templateId}`)
    })

    // Le formulaire est sous les carrousels : on le ramène à l'écran
    this.completionFormTargets
      .find(form => form.id === `completion-form-${templateId}`)
      ?.scrollIntoView({ behavior: "smooth", block: "nearest" })
  }
}
